var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.camera)?_c('div',[_c('CameraItem',{attrs:{"camera":_vm.camera,"fullscreen":true}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }